import { useRef } from "react";
import ProgressBar from "../../component/ProgressBar";
import RanderComponent from "../../component/RanderComponent";
import useWebViewMessage from "../../hooks/useHandleMessage";
import useScrollStep from "../../hooks/useScrollStep";
function SignUpInfo() {
  const stepRef = useRef([]);
  const totalSteps = 7;
  const [userLanguage] = useWebViewMessage();
  const [currentStep, setCurrentStep] = useScrollStep(stepRef, totalSteps);

  const scrollToStep = (step) => {
    const element = stepRef.current[step - 1];
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    userLanguage !== "" && (
      <div>
        <ProgressBar
          currentStep={currentStep}
          totalSteps={totalSteps}
          handleStepClick={scrollToStep}
        />
        <RanderComponent
          totalNumber={totalSteps}
          ref={stepRef}
          textInfo={"signUp"}
          imgInfo={"signup"}
          isKiosk={false}
          userLanguage={userLanguage}
        />
      </div>
    )
  );
}

export default SignUpInfo;
